<div class="grid">
  <div class="col-12 md:ml-5 py-4">
    <div class="flex-auto flex-wrap justify-content-center">
      <div class="col-12 mb-3">
        <div class="md:ml-2 mt-2">
          <div>
            <span class="institution">{{ 'Billing_Info.Institution' | translate }}</span>
          </div>
        </div>
      </div>
      <div class="col-12 flex">
        <div class="col-2">
          <span class="label">{{ 'Billing_Info.Name' | translate }}:</span>
        </div>
        <div class="col-10">
          <span class="span-text">{{ customerOrganization?.name }}</span>
        </div>
      </div>
      <div class="col-12 flex">
        <div class="col-2">
          <span class="label">{{ 'Billing_Info.Address' | translate }}:</span>
        </div>
        <div class="col-10">
          <span class="span-text">{{ address }}</span>
        </div>
      </div>

      @if (!hideCountrySelection) {
<div class="col-12 flex">
        <div class="md:col-4">
          <span class="label">{{ 'Billing_Info.ThisOrderisfor' | translate }}</span>
        </div>
        <div class="col-8">
          <span class="field-checkbox">
            <p-checkbox [binary]="true"
              inputId="isGermanChecked"
              class="pb-2 mr-2"
              [(ngModel)]="isGermanChecked"
              binary="true"
              (onChange)="isGermanNotChecked = !isGermanChecked" /><label for="isGermanChecked" class="ml-2">{{ 'Common.Yes' | translate }}</label>
            <p-checkbox [binary]="true"
              inputId="isGermanNotChecked"
              class="pb-2"
              [(ngModel)]="isGermanNotChecked"
              binary="true"
              label="Check to show content"
              (onChange)="isGermanChecked = !isGermanNotChecked" /><label for="isGermanNotChecked" class="ml-2">{{ 'Common.No' | translate }}</label>
          </span>
        </div>
      </div>
}

      @if (isGermanChecked && !isGermanNotChecked) {
<div>
        <div class="col-12 flex">
          <div class="col-5 align-content-center">
            <span class="label">{{ 'Billing_Info.Healthinsurancetype.Label' | translate }}</span>
          </div>
          <div class="col-7 radioBtns">
            <div>
              <p-radioButton inputId="rbPublicHealth" formControlName="" />
              <label for="rbPublicHealth" class="ml-2">{{
                'Billing_Info.Healthinsurancetype.PublicHealth' | translate
              }}</label>
            </div>
            <div class="pl-4 pb-3 pt-1 labelNoteOpt">
              <div>
                <span>{{ 'Billing_Info.Healthinsurancetype.PublicHealthLine1' | translate }}</span>
              </div>
              <div>
                <span>{{ 'Billing_Info.Healthinsurancetype.PublicHealthLine2' | translate }}</span>
              </div>
              <div class="flex pt-2">
                <span class="label mr-2">{{ 'Billing_Info.Healthinsurancetype.Reason' | translate }}</span>
                <p-radioButton class="mr-2" inputId="rbIndication" formControlName="" />
                <label for="rbIndication" class="ml-2">{{
                  'Billing_Info.Healthinsurancetype.Indication' | translate
                }}</label>
                <p-radioButton class="mr-2" inputId="rbPersonal" formControlName="" />
                <label for="rbPersonal" class="ml-2">{{
                  'Billing_Info.Healthinsurancetype.Personal' | translate
                }}</label>
              </div>
            </div>
            <div class="pb-3">
              <p-radioButton class="mr-2" inputId="rbPrivateHealth" formControlName="consent" />
              <label for="rbPrivateHealth" class="ml-2">{{
                'Billing_Info.Healthinsurancetype.PrivateHealth' | translate
              }}</label>
            </div>
            <div class="pb-3">
              <p-radioButton class="mr-2" inputId="rbIndividualHealth" formControlName="consent" />
              <label for="rbIndividualHealth" class="ml-2">{{
                'Billing_Info.Healthinsurancetype.IndividualHealth' | translate
              }}</label>
            </div>
          </div>
        </div>

        <div class="col-12 flex">
          <div class="col-5 align-content-center">
            <span class="label">{{ 'Billing_Info.Healthinsurancetype.Label' | translate }}</span>
          </div>
          <div class="col-7">
            <div class="pb-3">
              <p-radioButton class="mr-2" inputId="rbPublicHealth" />
              <label for="rbPublicHealth" class="ml-2">{{
                'Billing_Info.Healthinsurancetype.PublicHealth' | translate
              }}</label>
            </div>
            <div class="pb-3">
              <p-radioButton class="mr-2" inputId="rbPrivateHealth" />
              <label for="rbPrivateHealth" class="ml-2">{{
                'Billing_Info.Healthinsurancetype.PrivateHealth' | translate
              }}</label>
            </div>
            <div class="pb-3">
              <p-radioButton class="mr-2" inputId="rbIndividualHealth" />
              <label for="rbIndividualHealth" class="ml-2">{{
                'Billing_Info.Healthinsurancetype.IndividualHealth' | translate
              }}</label>
            </div>
          </div>
        </div>
        <div class="col-12 flex">
          <div class="col-5 align-content-center">
            <span class="label">{{ 'Billing_Info.HealthinsuranceCompany' | translate }}</span>
          </div>
          <div class="col-7">
            <div class="flex">
              <input pInputText id="" class="col-7" />
            </div>
          </div>
        </div>
        <div class="col-12 flex">
          <div class="col-5 align-content-center">
            <span class="label">{{ 'Billing_Info.HealthinsuranceIdentifier' | translate }}</span>
          </div>
          <div class="col-7">
            <div class="flex">
              <input pInputText id="" class="col-7" />
            </div>
          </div>
        </div>

        <span class="institution mt-2 pl-3">{{ 'Billing_Info.Patient' | translate }}</span>
        <div class="col-12 flex">
          <div class="col-5 align-content-center">
            <span class="label">{{ 'Billing_Info.HealthinsuranceNumber' | translate }}</span>
          </div>
          <div class="col-7">
            <div class="flex">
              <input pInputText id="" class="col-7" />
            </div>
          </div>
        </div>
        <div class="col-12 flex">
          <div class="col-5 align-content-center">
            <span class="label">{{ 'Billing_Info.Patientsfirstname' | translate }} *</span>
          </div>
          <div class="col-7">
            <div class="flex">
              <input pInputText id="" class="col-7" />
            </div>
          </div>
        </div>
        <div class="col-12 flex">
          <div class="col-5 align-content-center">
            <span class="label">{{ 'Billing_Info.Patientslastname' | translate }} *</span>
          </div>
          <div class="col-7">
            <div class="flex">
              <input pInputText id="" class="col-7" />
            </div>
          </div>
        </div>

        <div class="col-12 flex">
          <div class="col-5 align-content-center">
            <span class="label">{{ 'Billing_Info.Patientsdob' | translate }} *</span>
          </div>
          <div class="col-7">
            <div class="flex">
              <div class="md:col-7 p-0">
                <p-datepicker [readonlyInput]="true"
                  [showOnFocus]="false"
                  dateFormat="dd/mm/yy"
                  placeholder="DD/MM/YYYY"
                  [showIcon]="true"
                  styleClass="w-full" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 flex">
          <div class="col-5 align-content-center">
            <span class="label">{{ 'Billing_Info.Status' | translate }}</span>
          </div>
          <div class="col-7">
            <div class="flex">
              <div class="col-7 p-0">
                <p-select id="" styleClass="w-full" placeholder="{{ 'Billing_Info.Member' | translate }}" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 flex">
          <div class="col-5 align-content-center">
            <span class="label">{{ 'Billing_Info.Address' | translate }}</span>
          </div>
          <div class="col-7">
            <div class="flex">
              <input pInputText id="" class="col-7" />
            </div>
          </div>
        </div>
        <div class="col-12 flex">
          <div class="col-5 align-content-center">
            <span class="label">{{ 'Billing_Info.Region' | translate }}</span>
          </div>
          <div class="col-7">
            <div class="flex">
              <div class="col-7 p-0">
                <p-select id="" styleClass="w-full" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 flex">
          <div class="col-5 align-content-center">
            <span class="label">{{ 'Billing_Info.Zipcode' | translate }}</span>
          </div>
          <div class="col-7">
            <div class="flex">
              <input pInputText id="" class="col-7" />
            </div>
          </div>
        </div>
        <div class="col-12 flex">
          <div class="col-5 align-content-center">
            <span class="label">{{ 'Billing_Info.City' | translate }}</span>
          </div>
          <div class="col-7">
            <div class="flex">
              <div class="col-7 p-0">
                <p-select id="" styleClass="w-full" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 flex">
          <div class="col-5 align-content-center">
            <span class="label">{{ 'Billing_Info.Country' | translate }}</span>
          </div>
          <div class="col-7">
            <div class="flex">
              <input pInputText id="" class="col-7" [disabled] />
            </div>
          </div>
        </div>

        <h5 class="mt-2 pl-3">{{ 'Billing_Info.Doctor' | translate }}</h5>
        <div class="col-12 flex">
          <div class="col-5 align-content-center">
            <span class="label">{{ 'Billing_Info.Establishment' | translate }}</span>
          </div>
          <div class="col-7">
            <div class="flex">
              <input pInputText id="" class="col-7" />
            </div>
          </div>
        </div>
        <div class="col-12 flex">
          <div class="col-5 align-content-center">
            <span class="label">{{ 'Billing_Info.DoctorsID' | translate }}</span>
          </div>
          <div class="col-7">
            <div class="flex">
              <input pInputText id="" class="col-7" [disabled] />
            </div>
          </div>
        </div>
        <div class="col-12 flex">
          <div class="col-5 align-content-center">
            <span class="label">{{ 'Billing_Info.Date' | translate }}</span>
          </div>
          <div class="col-7">
            <div class="flex">
              <div class="md:col-7 p-0">
                <p-datepicker [readonlyInput]="true"
                  [showOnFocus]="false"
                  dateFormat="dd/mm/yy"
                  placeholder="DD/MM/YYYY"
                  [showIcon]="true"
                  styleClass="w-full" />
              </div>
            </div>
          </div>
        </div>
      </div>
}
    </div>
  </div>
</div>
